export default __webpack_public_path__ + "static/media/Apple-Books-Logo.e6c0ca10.png";